<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class=""
      >Gerar contrato da seguinte proposta.</mat-card-title
    >
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-5 container mx-auto">
    <mat-card class="card-style px-4 py-6 mt-3">
      <div class="flex justify-between gap-2 mt-4 mb-2">
        <div><strong>TG:</strong> {{ item.codigoTg }}</div>
        <div><strong>Evento:</strong> {{ item.nomeEvento }}</div>
      </div>
      <div class="flex justify-between gap-2 mt-4 mb-2">
        <div>
          <strong>Período:</strong> {{ item.dataInicio }} - {{ item.dataFim }}
        </div>
        <div><strong>Emissão:</strong> {{ item.dataCriacao }}</div>
      </div>
      <div class="flex justify-between gap-2 mt-4 mb-2">
        <div><strong>Cliente:</strong> {{ item.nomeCliente }}</div>
        <div>
          @if (item.nomeSubCliente) {
            <br /><strong>Subcliente:</strong> {{ item.nomeSubCliente ?? '-' }}
          }
        </div>
        <div><strong>Valor</strong> {{ item.valorTotalFormatado }}</div>
      </div>
      <div class="flex justify-between gap-2 mt-4 mb-2">
        <div><strong>Solicitante:</strong> {{ item.solicitante }}</div>
        <div><strong>Email:</strong> {{ item.solicitanteEmail }}</div>
        <div>
          <strong>Telefone</strong> {{ item.solicitanteTelefone | telefone }}
        </div>
      </div>
    </mat-card>
    @if (!loading) {
      <div class="flex justify-center gap-4 py-2 px-6 mt-6 items-center">
        <button
          mat-flat-button
          class="btn-tg w-2/5"
          [disabled]="loading"
          (click)="createContract()"
        >
          @if (loading) {
            <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
          } @else {
            Gerar Contrato
          }
        </button>
        <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
      </div>
    } @else {
      <mat-divider></mat-divider>
      <div class="flex flex-col items-center gap-4">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</mat-card>
